import { Component, Input } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-tag',
	imports: [SharedModule],
	templateUrl: './tag.component.html',
	styleUrl: './tag.component.scss',
})
export class TagComponent {
	@Input() label = 'Tag';
	@Input() color:
		| 'yellow'
		| 'blue'
		| 'green'
		| 'red'
		| 'gray'
		| 'gray-light'
		| 'gray-medium'
		| 'green-solid'
		| 'green-medium'
		| 'red-solid' = 'gray';
	@Input() size: 'small' | 'large' = 'large';
	@Input() variant: 'status' | 'glass' = 'status';
	/** Lucide icon name rendered before the label (status variant only). */
	@Input() icon?: string;
}
